import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Button
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const ServerDetailsModal = ({
  isOpen,
  toggle,
  server,
  onManageFlashcards,
  fetchServers
}) => {
  const [serverForm, setServerForm] = useState({
    server_id: "",
    username: "",
    access_code: ""
  });

  const [saving, setSaving] = useState(false);

  // ✅ Populate form when modal opens
  useEffect(() => {
    if (server) {
      setServerForm({
        server_id: server.server_id,
        username: server.user_name || "",
        access_code: server.access_code || ""
      });
    }
  }, [server]);

  if (!server) return null;

  // ✅ Save / Update Server
  const handleSaveServer = () => {
    if (!serverForm.username || !serverForm.access_code) {
      alert("Username and Access Code are required");
      return;
    }

    setSaving(true);

    postDataAPI({
      serviceName: "server_data",
      op: "server_coaching_save_server",
      server_id: serverForm.server_id,          // 🔴 update key
      server_user_name: serverForm.username,
      access_code: serverForm.access_code
    })
      .then((res) => {
        if (res.status === "ok") {
          toggle();        // close modal
          fetchServers(); // refresh table
        } else {
          alert(res.message || "Failed to update server");
        }
      })
      .finally(() => setSaving(false));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        Server Details
        <div className="text-muted small">
          Manage credentials and trainings for {server.name}
        </div>
      </ModalHeader>

      <ModalBody>
        <Label>Name</Label>
        <p className="fw-medium">{server.name}</p>

        <Label className="mt-2">Username</Label>
        <Input
          value={serverForm.username}
          onChange={(e) =>
            setServerForm({ ...serverForm, username: e.target.value })
          }
        />

        <Label className="mt-3">Access Code</Label>
        <Input
          value={serverForm.access_code}
          onChange={(e) =>
            setServerForm({ ...serverForm, access_code: e.target.value })
          }
        />

        <Label className="mt-3">Assigned Trainings</Label>
        <div className="d-flex justify-content-between align-items-center">
          <span>{(server.flash_cards).length || 0} flashcards</span>
          <Button size="sm" outline onClick={onManageFlashcards} disabled={server.user_name==="" || server.access_code===""}>
            Manage Flashcards
          </Button>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={handleSaveServer}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ServerDetailsModal;
